import { FC } from 'react';
import { TradeGuaranteePlan } from './TradeGuaranteePlan';

type TradeGuaranteePlanPageProps = {};

export const TradeGuaranteePlanPage: FC<TradeGuaranteePlanPageProps> = () => {
  return <TradeGuaranteePlan />;
};
